import moment from 'moment'

// 计算输入时间与当前时间之间的天数差异
export const daysBetweenDates = (inputDate: string): number => {
    // 验证输入日期的格式
    const inputMoment = moment(inputDate, 'YYYY-MM-DD', true)
    if (!inputMoment.isValid()) {
        throw new Error('时间格式为: YYYY-MM-DD')
    }

    // 获取当前日期
    const currentDate = moment()

    // 计算两个日期之间的天数差异
    const diffInDays = currentDate.diff(inputMoment, 'days')

    return diffInDays
}

// 计算输入时间与当前时间之间的天数是否小于30天
export const daysBetweenDatesUnder30 = (inputDate: string): boolean => {
    return daysBetweenDates(inputDate) <= 30
}

/**
 * 校验当前时间是否超过下线时间
 * @param {string} inputDate - 下线时间
 * @returns {boolean} - 返回当前时间是否超过下线时间
 */
export const checkExceedOfflineTime = (inputDate: string): boolean => {
    // 验证输入日期的格式
    const inputMoment = moment(inputDate, 'YYYY-MM-DD', true)
    if (!inputMoment.isValid()) {
        throw new Error('时间格式为: YYYY-MM-DD')
    }

    // 获取当前日期
    const currentDate = moment()

    return currentDate.isAfter(inputMoment, 'day')
}
